import { makeVar } from '@apollo/client';

export const isClassSelectionVisibleVar = makeVar<boolean>(false);

export function setIsClassSelectionVisible(value: boolean): void {
  isClassSelectionVisibleVar(value);
}

export function getIsClassSelectionVisible(): boolean {
  return isClassSelectionVisibleVar();
}

export function resetClassSelectionVisible(): void {
  isClassSelectionVisibleVar(false);
}
